import type { PresentatorItem } from './types';
import { ProfileForm } from './ProfileForm';
import type { ProfileData } from './types';


export interface ProfileViewProps {
    profileData: ProfileData;
    username: string;
    profileId: string;
    onUpdateFormItem?: (args: {
        profileId: string;
        username: string;
        telephoneE164: string;
        key?: string | null;
        item: PresentatorItem;
    }) => Promise<void>;
    registerTourTarget?: (id: string, el: HTMLElement | null) => void;
}

export function ProfileView({
    profileData,
    username,
    profileId,
    onUpdateFormItem,
    registerTourTarget,
}: ProfileViewProps) {
    if (!profileData?.forms?.length) return null;
    return (
        <div className="space-y-4 relative mb-8">
            <div className="flex flex-col gap-4">
                {profileData.forms.map((form, idx) => (
                    <ProfileForm
                        key={`profile_form_${profileId}_${idx}`}
                        profileForm={form}
                        username={username}
                        profileId={profileId}
                        onUpdateFormItem={onUpdateFormItem}
                        registerTourTarget={registerTourTarget}
                    />
                ))}
            </div>
        </div>
    );
}
